import React, { useState } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Link, useHistory } from "react-router-dom";
import Sublink from "./components/Sublink";
import "./css/sideNav.css";

import Header from "./components/header/Header";
import RoutesFile from "../Routes/RoutesFile";
import DropDownNav from "./components/DropDownNav";
import SingleNav from "./components/SingleNav";
import { Navbar_items } from "./NavbarItems";
import { ArrowCircleRight, Power } from "phosphor-react";
import { useEffect } from "react";
import SideComponent from "./components/SideComponent/SideComponent";
import Notification_sm from "./components/small_Notfication/Notification_sm";
import { useRef } from "react";
import Profile from "./components/header/Profile";
import { showToast } from "../../utils/ToastHelper";
import { BASE_URL } from "../Const/Url";
import axios from "axios";
import Loader from "../CustomCommons/Loader";
import { logout_func2 } from "../Const/logoutCommon";

const SideNav = () => {
  // for nav dropdown
  const [Inventory, setInventory] = useState("Inventory");
  const [User, setUser] = useState("User");
  const [Sales, setSales] = useState("Sales");
  const [notificationCount, setNotificationCount] = useState({});
  const [isLoading2, setIsLoading2] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  // Read userProfile from state so it can be updated dynamically
  const [userProfile, setUserProfile] = useState(() => {
    try {
      const data = window.localStorage.getItem("userData");
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  });
  const [userData, setUserData] = useState({});
  // State to track permissions and force re-render when they change
  const [permissionsKey, setPermissionsKey] = useState(0);

  console.log(userProfile?.hide_section, "data 32");
  // for nav dropdown
  const [navbarWIdth, setnavbarWIdth] = useState(1);
  const [Shownotification, SetShownotification] = useState(0);
  const [showUser, SetShowUser] = useState(1);
  const [arrow, setArrow] = useState(true);
  const ToggleNav = () => {
    setnavbarWIdth(!navbarWIdth);
  };
  const [HideNav, SetHideNav] = useState(0);
  const [CollapseState, SetCollapseState] = useState({
    Inventory: false,
    Sales: false,
    User: false,
    Reports: false,
    Customers: false,
  });
  const compareArrays = (array1, array2) => {
    if (Array.isArray(array1) && Array.isArray(array2)) {
      return array1.length >= array2.length ? array1 : array2;
    } else if (!Array.isArray(array1) && Array.isArray(array2)) {
      return array2;
    } else {
      // In all other cases, including when array1 is null and array2 is an array
      return array2;
    }
  };
  console.log(
    compareArrays(
      userProfile?.hide_section,
      JSON.parse(localStorage.getItem("userData"))?.hide_section
    ),
    "data 62"
  );
  const renderContent = (text, component) => {
    // const getData = JSON.parse(localStorage.getItem("userData"));
    // const data =
    // getData && getData?.hide_section ? userData?.hide_section : [];
    const data = compareArrays(
      userProfile?.hide_section,
      JSON.parse(localStorage.getItem("userData"))?.hide_section
    );
    const isMatch = data?.some((option) => option.label === text);
    if (isMatch) {
      return <></>;
    } else {
      return component;
    }
  };
  const imgNotif = useRef();
  const userNotif = useRef();
  const userNotif2 = useRef();
  const userNotif3 = useRef();
  const inventory = useRef();
  const sales = useRef();
  const user = useRef();

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const updateDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  useEffect(() => {
    if (width < 900) {
      setnavbarWIdth(0);
    } else {
      setnavbarWIdth(1);
    }
  }, [width]);

  const HandleNotificationClick = () => {
    SetShownotification((prev) => !prev);
  };
  const HandleShowUser = () => {
    SetShowUser((prev) => !prev);
    setArrow((prev) => !prev);
  };

  useEffect(() => {
    const closeDropdown = (e) => {
      e.path !== undefined &&
        e.path[0] !== imgNotif.current &&
        SetShownotification(0);
    };
    document.body.addEventListener("click", closeDropdown);
    return () => document.body.removeEventListener("click", closeDropdown);
  }, []);
  useEffect(() => {
    const closeUser = (e) => {
      e.path !== undefined && e.path[0] !== userNotif.current && SetShowUser(1);
      e.path !== undefined && e.path[0] !== userNotif.current && setArrow(true);
    };
    document.body.addEventListener("click", closeUser);
    return () => document.body.removeEventListener("click", closeUser);
  }, []);
  // =====================

  const [notificationList, setNotificationList] = useState([]);
  const getNotification = () => {
    const url = `${BASE_URL}api/v1/users/inventory/notifications/`;
    axios
      .get(url)
      .then((res) => {
        // console.log(res.data.data.results);
        const result = res.data.data.results;
        setNotificationList(result);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
        if (
          message === "Invalid token." ||
          JSON.parse(err?.request?.response)?.code === 401
        ) {
          history.push("/login");
          // logout_func2(0,history)
          setIsLoading(false);
        }
      });
  };
  const getNotificationCount = () => {
    const url = `${BASE_URL}api/v1/utility/admin/dashboard-notifications/`;
    axios
      .get(url)
      .then((res) => {
        // console.log(res.data.data.results);
        const result = res.data.data.results;
        setNotificationCount(result);
        setIsLoading(false);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
        if (
          message === "Invalid token." ||
          JSON.parse(err?.request?.response)?.code === 401
        ) {
          history.push("/login");
          // logout_func2(0,history)
        }
        setIsLoading(false);
      });
  };
  useEffect(() => {
    getNotificationCount();
  }, []);
  const getUser = () => {
    const url = `${BASE_URL}api/v1/auth/profile/`;
    axios
      .get(url)
      .then((res) => {
        setIsLoading2(true);
        // console.log(res.data.data);
        // console.log(res.data.data.results);
        const result = res.data.data;
        setUserData(result);
        // console.log(userData,'-------------')
        setIsLoading2(false);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
        if (
          message === "Invalid token." ||
          JSON.parse(err.request.response).code === 401
        ) {
          history.push("/login");
          // logout_func2(0,history)
          setIsLoading(false);
        }
      });
  };
  useEffect(() => {
    getUser();
  }, []);

  // Monitor localStorage changes for userData to update sidebar when permissions change
  useEffect(() => {
    const checkPermissions = () => {
      try {
        const currentUserData = localStorage.getItem("userData");
        if (currentUserData) {
          const parsed = JSON.parse(currentUserData);
          const currentPermissions = JSON.stringify(parsed?.permissions || []);
          const storedPermissions = JSON.stringify(userProfile?.permissions || []);
          
          // If permissions changed, update userProfile and force re-render
          if (currentPermissions !== storedPermissions) {
            setUserProfile(parsed);
            setPermissionsKey(prev => prev + 1);
          }
        }
      } catch (error) {
        console.error('Error checking permissions:', error);
      }
    };

    // Check permissions on mount
    checkPermissions();

    // Listen for storage events (when localStorage is updated from another tab/window)
    const handleStorageChange = (e) => {
      if (e.key === 'userData') {
        try {
          const newData = e.newValue ? JSON.parse(e.newValue) : null;
          setUserProfile(newData);
          setPermissionsKey(prev => prev + 1);
        } catch (error) {
          console.error('Error parsing storage event:', error);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Also check periodically (in case same-tab updates don't trigger storage event)
    // This handles the case when user logs in again in the same tab
    const interval = setInterval(checkPermissions, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [userProfile?.permissions]);

  const history = useHistory();
  const logout_func = () => {
    localStorage.removeItem("is_logged_in");
    localStorage.removeItem("access_token");
    localStorage.removeItem("userData");
    showToast("success", "Logged Out Successfully");

    history.push("/login");
  };

  if (isLoading) {
    return <Loader />;
  }
  // components
  const Dashboard = Navbar_items["Dashboard"] ? (
    <SingleNav
      SetCollapseState={SetCollapseState}
      CollapseState={CollapseState}
      toggle={navbarWIdth}
      to={Navbar_items["Dashboard"].to}
      name={"Dashboard"}
      icon={Navbar_items["Dashboard"].icon}
      count={0}
    />
  ) : null;
  const PDashboard = Navbar_items["Categories"] ? (
    <SingleNav
      SetCollapseState={SetCollapseState}
      CollapseState={CollapseState}
      toggle={navbarWIdth}
      to={Navbar_items["Categories"].to}
      name={"P. Dashboard"}
      icon={Navbar_items["Categories"].icon}
      count={0}
    />
  ) : null;
  const InventoryTab = Navbar_items["Inventory"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Inventory"
      icon={Navbar_items["Inventory"].icon}
      sublinks={Navbar_items["Inventory"].sublinks}
      sendName={"Inventory"}
      ref={inventory}
      SetCollapseState={SetCollapseState}
      CollapseState={CollapseState}
      object={notificationCount[0]}
    />
  ) : null;
  const Combo = Navbar_items["Combo"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Combo"
      icon={Navbar_items["Combo"].icon}
      sublinks={Navbar_items["Combo"].sublinks}
      sendName={"Combo"}
      ref={inventory}
      SetCollapseState={SetCollapseState}
      CollapseState={CollapseState}
      object={notificationCount[0]}
    />
  ) : null;
  const NewArrival = Navbar_items["New_Arrival"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="New_Arrival"
      icon={Navbar_items["New_Arrival"].icon}
      sublinks={Navbar_items["New_Arrival"].sublinks}
      sendName={"New_Arrival"}
      ref={inventory}
      SetCollapseState={SetCollapseState}
      CollapseState={CollapseState}
      object={notificationCount[0]}
    />
  ) : null;
  const Highlighted = Navbar_items["Highlighted"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Highlighted"
      icon={Navbar_items["Highlighted"].icon}
      sublinks={Navbar_items["Highlighted"].sublinks}
      sendName={"Highlighted"}
      ref={inventory}
      SetCollapseState={SetCollapseState}
      CollapseState={CollapseState}
      object={notificationCount[0]}
    />
  ) : null;
  const Trending = Navbar_items["Trending"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Trending"
      icon={Navbar_items["Trending"].icon}
      sublinks={Navbar_items["Trending"].sublinks}
      sendName={"Trending"}
      ref={inventory}
      SetCollapseState={SetCollapseState}
      CollapseState={CollapseState}
      object={notificationCount[0]}
    />
  ) : null;
  const Festival = Navbar_items["Festival"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Festival"
      icon={Navbar_items["Festival"].icon}
      sublinks={Navbar_items["Festival"].sublinks}
      sendName={"Festival"}
      ref={inventory}
      SetCollapseState={SetCollapseState}
      CollapseState={CollapseState}
      object={notificationCount[0]}
    />
  ) : null;
  const Matching = Navbar_items["Matching"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Matching"
      icon={Navbar_items["Matching"].icon}
      sublinks={Navbar_items["Matching"].sublinks}
      sendName={"Matching"}
      ref={inventory}
      SetCollapseState={SetCollapseState}
      CollapseState={CollapseState}
      object={notificationCount[0]}
    />
  ) : null;

  const SalesTab = Navbar_items["Sales"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Sales"
      icon={Navbar_items["Sales"].icon}
      sublinks={Navbar_items["Sales"].sublinks}
      sendName={"Invoice List"}
      ref={sales}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
      count={notificationCount[0]?.invoice}
      object={notificationCount[0]}
    />
  ) : null;
  const Customers = Navbar_items["Customers"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Customers"
      icon={Navbar_items["Customers"].icon}
      sublinks={Navbar_items["Customers"].sublinks}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
      object={notificationCount[0]}
    />
  ) : null;
  const Outlets = Navbar_items["Outlets"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Outlets"
      icon={Navbar_items["Outlets"].icon}
      sublinks={Navbar_items["Outlets"].sublinks}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
      object={notificationCount[0]}
    />
  ) : null;
  const Promotions = Navbar_items["Promotions"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Promotions"
      icon={Navbar_items["Promotions"].icon}
      sublinks={Navbar_items["Promotions"].sublinks}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
      count={notificationCount[0]?.review}
      object={notificationCount[0]}
    />
  ) : null;
  const Settings = Navbar_items["Settings"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Settings"
      icon={Navbar_items["Settings"].icon}
      sublinks={Navbar_items["Settings"].sublinks}
      sendName={"Settings"}
      // ref={user}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
      object={notificationCount[0]}
    />
  ) : null;
  const Reports = Navbar_items["Reports"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Reports"
      icon={Navbar_items["Reports"].icon}
      sublinks={Navbar_items["Reports"].sublinks}
      sendName={"Reports"}
      // ref={user}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
      object={notificationCount[0]}
    />
  ) : null;

  const Custom = Navbar_items["Custom"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Custom"
      icon={Navbar_items["Custom"].icon}
      sublinks={Navbar_items["Custom"].sublinks}
      sendName={"Custom"}
      // ref={user}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
    />
  ) : null;
  const Purchase = Navbar_items["Purchase"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Purchase"
      icon={Navbar_items["Purchase"].icon}
      sublinks={Navbar_items["Purchase"].sublinks}
      sendName={"Purchase"}
      // ref={user}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
    />
  ) : null;
  const Requisition = Navbar_items["Requisition"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Requisition"
      icon={Navbar_items["Requisition"].icon}
      sublinks={Navbar_items["Requisition"].sublinks}
      sendName={"Requisition"}
      // ref={user}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
    />
  ) : null;
  const NotificationCom = Navbar_items["Notification"] ? (
    <SingleNav
      SetCollapseState={SetCollapseState}
      CollapseState={CollapseState}
      toggle={navbarWIdth}
      to={Navbar_items["Notification"].to}
      name={"Notification"}
      icon={Navbar_items["Notification"].icon}
      count={notificationCount[0]?.notification}
      object={notificationCount[0]}
    />
  ) : null;
  const Users = Navbar_items["User"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="User"
      icon={Navbar_items["User"].icon}
      sublinks={Navbar_items["User"].sublinks}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
      count={notificationCount[0]?.user}
      object={notificationCount[0]}
    />
  ) : null;
  const Employe = Navbar_items["Employe"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Employe"
      icon={Navbar_items["Employe"].icon}
      sublinks={Navbar_items["Employe"].sublinks}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
      count={notificationCount[0]?.user}
      object={notificationCount[0]}
    />
  ) : null;
  const Theme = Navbar_items["Theme"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Theme"
      icon={Navbar_items["Theme"].icon}
      sublinks={Navbar_items["Theme"].sublinks}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
    />
  ) : null;

  const WebsiteSettings = Navbar_items["Web_Settings"] ? (
    <DropDownNav
      toggle={navbarWIdth}
      name="Web_Settings"
      icon={Navbar_items["Web_Settings"].icon}
      sublinks={Navbar_items["Web_Settings"].sublinks}
      CollapseState={CollapseState}
      SetCollapseState={SetCollapseState}
    />
  ) : null;

  return (
    <>
      <div className="mainContainer">
        {!HideNav && (
          <Header
            imgRef={imgNotif}
            navbarWIdth={navbarWIdth}
            onBurgerClick={ToggleNav}
            HandleNotificationClick={HandleNotificationClick}
            userNotif={userNotif}
            getNotification={getNotification}
            HandleShowUser={HandleShowUser}
            arrow={arrow}
          />
        )}
        <div
          id="body-pd"
          className={`${!HideNav & navbarWIdth ? "body-pd" : ""}`}
        >
          <div
            className={` ${!HideNav ? "l-navbar" : "hide-navbar"} ${
              !HideNav & navbarWIdth ? "expander" : ""
            }`}
            id="navbar"
          >
            <nav className="nav">
              <div>
                <div className="nav__brand"></div>
                <div className="nav__list mt-3">
                  {renderContent("Dashboard", Dashboard)}
                  {renderContent("P. Dashboard", PDashboard)}
                  {renderContent("Inventory", InventoryTab)}
                  {/* {renderContent("Combo", Combo)} */}
                  {renderContent("Theme", Theme)}
                  {renderContent("New Arrivals", NewArrival)}

                  {renderContent("Trending", Trending)}
                  {renderContent("Festival", Festival)}
                  {renderContent("Highlighted", Highlighted)}
                  {/* {renderContent("Matching", Matching)} */}

                  {renderContent("Sales", SalesTab)}
                  {/* <DropDownNav
                  toggle={navbarWIdth}
                    name="Draft"
                    icon={Navbar_items["Draft"].icon}
                    sublinks={Navbar_items["Draft"].sublinks}
                    sendName={"Draft"}
                    ref={sales}
                    CollapseState={CollapseState}
                    SetCollapseState={SetCollapseState}
                    count={notificationCount[0]?.invoice}
                    object={notificationCount[0]}
                  /> */}

                  {renderContent("Customers", Customers)}
                  {renderContent("Outlets", Outlets)}
                  {renderContent("Web Settings", WebsiteSettings)}
                  {renderContent("Promotions", Promotions)}
                  {renderContent("Settings", Settings)}
                  {renderContent("Reports", Reports)}
                  {renderContent("Custom", Custom)}
                  {renderContent("Purchases", Purchase)}
                  {renderContent("Requisitions", Requisition)}
                  {renderContent("Notifications", NotificationCom)}
                  {/* <DropDownNav
                    toggle={navbarWIdth}
                    name="User"
                    icon={Navbar_items["User"].icon}
                    sublinks={Navbar_items["User"].sublinks}
                    CollapseState={CollapseState}
                    SetCollapseState={SetCollapseState}
                    count={notificationCount[0]?.user}
                    object={notificationCount[0]}
                  /> */}
                  {renderContent("Employee", Employe)}
                  {renderContent("User", Users)}
                </div>
              </div>

              <div onClick={logout_func} to="#" className="logout_nav__link">
                <Power className="logout__nav__icon" size={24} />
                {navbarWIdth && (
                  <span className="logout__nav__name">Log Out</span>
                )}
              </div>
            </nav>
          </div>
          <div className={`${!HideNav && "OtherComponents"} `}>
            {/* <div className={`OtherComponents ${navbarWIdth&&"blur_background"}`}></div> */}
            <Notification_sm
              notificationList={notificationList ? notificationList : []}
              show={Shownotification}
            />
            {!showUser && <Profile />}
            {/* <a href="" style={{color:'black'}}> */}
            <SideComponent HideNav={HideNav} setHideToolbar={SetHideNav} />
            {/* </a> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SideNav;
